export default __webpack_public_path__ + "static/scarpe-593c15e741e3ba7cdd9dcef5e8af7329.jpg";